import { render, staticRenderFns } from "./SuiteSecurity.vue?vue&type=template&id=6903e69e&"
import script from "./SuiteSecurity.vue?vue&type=script&lang=js&"
export * from "./SuiteSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports